(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('RouterTransitionService', RouterTransitionService);
    /*USE: emitService('order:created', {data});*/
    RouterTransitionService.$inject = ['$rootScope'];
    /* @ngInject */
    function RouterTransitionService() {

        /** NAME:
         * $stateChangeStart
         * $stateChangeError
         * $stateChangeSuccess
         * $viewContentLoaded
         * $stateNotFound
         */
        var state = {
            name            : null,
            toState         : null,
            toParams        : null,
            fromState       : null,
            fromParams      : null,
            unfoundState    : null,
        };

        return {
            getState: getState,
            stateChangeStart: stateChangeStart,
            stateChangeError: stateChangeError,
            stateChangeSuccess: stateChangeSuccess,
            viewContentLoaded: viewContentLoaded,
            stateNotFound: stateNotFound
        }
        function clear(){
            state.name         = null;
            state.toState      = null;
            state.toParams     = null;
            state.fromState    = null;
            state.fromParams   = null;
            state.unfoundState = null;
        }
        function getState(){return state; }

        function stateChangeStart(toState, toParams, fromState, fromParams){
            clear();
            state.name         = 'stateChangeStart';
            state.toState      = toState;
            state.toParams     = toParams;
            state.fromState    = fromState;
            state.fromParams   = fromParams;
        }
        function stateChangeError(toState, toParams, fromState, fromParams){
            clear();
            state.name         = 'stateChangeError';
            state.toState      = toState;
            state.toParams     = toParams;
            state.fromState    = fromState;
            state.fromParams   = fromParams;
        }
        function stateChangeSuccess(toState, toParams, fromState, fromParams){
            clear();
            state.name         = 'stateChangeSuccess';
            state.toState      = toState;
            state.toParams     = toParams;
            state.fromState    = fromState;
            state.fromParams   = fromParams;
        }
        function viewContentLoaded(){
            clear();
            state.name         = 'viewContentLoaded';
        }
        function stateNotFound(unfoundState, fromState, fromParams){
            clear();
            state.name         = 'stateNotFound';
            state.fromState    = fromState;
            state.fromParams   = fromParams;
            state.unfoundState = unfoundState;
        }
    }
})();


/*****************
 ** WEBPACK FOOTER
 ** ./app/core/routerTransition.services.js
 ** module id = 156
 ** module chunks = 0
 **/